import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { styles } from "../theme/styles";
import { CustomButton } from "../components/CustomButton";
import { Creators as UsersCreators } from "../store/ducks/users";
import { connect } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { ClipLoader } from "react-spinners";
import {
  TextField,
  Card,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { DatosCompradorContext } from "../context/Context";
import { encodeData } from "../helpers/encode";
// import { config } from "dotenv";
const FormularioFormato = (props) => {
  const [selectedOption, setSelectedOption] = useState();
  const [selectedOption2, setSelectedOption2] = useState();
  const [reloadTipografia, setReloadTipografia] = useState();
  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext,
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    tiendaAsociadaAuxiliarContext,
    setTiendaAsociadaAuxiliarContext,
    idbuscadoContext,
    setIdbuscadoContext,
    skuContext,
    setSkucontext,
    setMostrarSelectTienda,
    mostrarSelectTienda,
  } = useContext(DatosCompradorContext);
  const navigate = useNavigate();
  const {
    users,
    token,
    storesInfo,
    storeId,
    getInfoByPostalCode,
    infoByPostalCode,
    userData,
    disabled,
  } = props;
  const auxURL = process.env.REACT_APP_BACK_APIVENTAANIMALES;
  const [style, setStyle] = useState({});
  const [SKU, setSKU] = useState("");
  const [tasaImportacionAprovechamiento, setTasaImportacionAProvechamiento] =
    useState("");
  const [tasaImportAux, setTasaImportAux] = useState(true);
  const [descripcionEjemplar, setDescripcionEjemplar] = useState("");
  const [descripcionEjemplarAux, setDescripcionEjemplarAux] = useState(true);
  const [nombreCientifico, setNombreCientifico] = useState("");
  const [nombreCientificoAux, setNombreCientificoAux] = useState(true);
  const [noPedimentoImportacionCITIES, setNoPedimentoImportacionCITIES] =
    useState("");
  const [noPedimentoAux, setNoPedimentoAux] = useState(true);
  const [tipoMarcajeNumeroMarcaje, setTipoMarcajeNumeroMarcaje] = useState("");
  const [tipoNumeroMarcajeAux, setTipoNumeroMArcajeAux] = useState(true);
  const [noAprovechamiento, setNoAprovechamiento] = useState("");
  const [noAprovechamientoAux, setNoAprovAux] = useState(true);
  const [sexoAnimal, setSexoAnimal] = useState();
  const [sexoAnimalAux, setSexoAnimalAux] = useState(true);
  const [loadingsppiner, setLoadingSpinner] = useState(false);
  const [datosPredioAprovechamiento, setDatosPredioAprovechamiento] =
    useState("");
  const [datosPredioAprovAux, setDatosPredioAprovAux] = useState(true);
  const [datosPredioAux, setDatosPredioAux] = useState(true);
  const [edad, setEdad] = useState("");
  const [edadAux, setEdadAux] = useState(true);
  const [pesoAproximado, setPesoAproximado] = useState("");
  const [pesoAproximadoAux, setPesoAproximadoAux] = useState(true);
  const [color, setColor] = useState("");
  const [colorAux, setColorAux] = useState(true);
  const [precio, setPrecio] = useState("");
  const [precioAux, setPrecioAux] = useState(true);
  const [telefonoSucursalAux, setTelefonoSucursalAux] = useState(false);
  const [telefonoSucursal, setTelefonoSucursal] = useState("");
  const [emailComprador, setEmailComprador] = useState("");
  const [emailCompradorAux, setEmailCompradorAux] = useState(true);
  const [nombreComprador, setnombreComprador] = useState();
  const [telefonoComprador, setTelefonoComprador] = useState();
  const [direccion, setDireccion] = useState();
  const [estado, setEstado] = useState();
  const [fecha, setFecha] = useState();
  const [vacunasYDesparacitacion, setVacunasyDesparasitacion] = useState();
  const [noMVZ, setNoMVZ] = useState();
  const [esterilizado, setEsterilizado] = useState();
  const [cedulaProfesional, setCedulaProfesional] = useState();
  const [autorizacionUsoInfoComprador, setAutorizacionUsoInformacion] =
    useState();
  const [AutorizacionInfoCompAux, setAutorizacionInfoCompAux] = useState(true);
  const [incluirHolograma, setIncluirHolograma] = useState("");
  const [incluirHologramaAux, setIncluirHologramaAux] = useState(true);
  const [selectedSexo, setSelectedSexo] = useState();
  const [selectedVacunas, setSelectedVacunas] = useState();
  const [selectedEsterilizacion, setSelectedEsterilizacion] = useState();
  const [fechaActual, setFechaActual] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [nombreVendedor, setNombreVendedor] = useState("");
  const [firmaVendedor, setFirmaVendedor] = useState();
  const [firmaComprador, setFirmaComprador] = useState("");
  const [MesFecha, setMesFecha] = useState("");
  const [diasFecha, setDiasFecha] = useState();
  const [aniosFecha, setAniosFecha] = useState();
  const [tienda, setTienda] = useState("");
  const [skuAux, setSKUaux] = useState(true);
  const [style2, setStyle2] = useState({});
  const [style3, setStyle3] = useState({});
  const [style4, setStyle4] = useState({});
  const [style5, setStyle5] = useState({});
  const [style6, setStyle6] = useState({});
  const [style7, setStyle7] = useState({});
  const [style8, setStyle8] = useState({});
  const [style9, setStyle9] = useState({});
  const [skuAux2, setSkuAux2] = useState();
  const [errorCP, setErrorCP] = useState(false);
  const [errorNameMvz, setErrorNameMvz] = useState(false);
  const [errorNameComprador, setErrorNameComprador] = useState(false);
  const [showVentana, setShowVentana] = useState(false);
  //console.log("EMAIL COMPRADOR", emailComprador);
  //console.log("NOMBRE DEL COMPRADOR", nombreComprador);
  //console.log("NO MVZ", noMVZ);
  //console.log("EMAIL COMPRADOR PENDIENTE", emailPendiente);

  const openVentanaEmergente = () => {
    setShowVentana(true);
  };

  const closeVentanaEmergente = () => {
    setShowVentana(false);
  };

  const altaCorreo = async () => {
    if (nombreComprador) {
      if (!isValidName(nombreComprador)) {
        Swal.fire({
          title: "Error",
          text: "El nombre del comprador debe contener nombre y apellido",
          icon: "error",
          iconColor: "red",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#00205B",
        });
        setErrorNameComprador(true);
        closeVentanaEmergente();
        return;
      } else {
        setErrorNameComprador(false);
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/data/postEmail/MX`,
            {
              nombre: `${nombreComprador}`,
              correo: `${emailComprador}`,
            },
            {
              headers: {
                Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                "Content-Type": "application/json",
              },
            },
          );
          // console.log("response", response.data);
          // console.log("response2", response.data.data);
          // console.log("response3", response.data.data.ids);
          if (response.data.data.ids.length > 0) {
            // console.log("SE CREO SOCIOOOOO");
            closeVentanaEmergente();
            Swal.fire({
              title: "Correo dado de alta",
              text: "Correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#00205B",
            });
          } else {
            /*Swal.fire({
            title: "No se pudo dar de alta el correo",
            icon: "error",
            confirmButtonText: "Aceptar",
            iconColor: "red",
            confirmButtonColor: "#00205B",
          });*/
          }
        } catch (error) {
          Swal.fire({
            title: "No se pudo dar de alta el correo",
            icon: "error",
            confirmButtonText: "Aceptar",
            iconColor: "red",
            confirmButtonColor: "#00205B",
          });
        }
      }
    } else {
      setErrorNameComprador(true);
      Swal.fire({
        title: "Llena el campo nombre de comprador",
        text: "Para dar de alta el correo",
        icon: "error",
        confirmButtonText: "Aceptar",
        iconColor: "red",
        confirmButtonColor: "#00205B",
      });
      closeVentanaEmergente();
    }
  };

  const handleComprobarClick = () => {
    if (SKU == "") {
      setStyle(styles.textField2);
      setSKUaux(false);
    }
    if (!SKU == "") {
      setStyle(styles.textField2);
      setSKUaux(true);
    }
    if (tasaImportacionAprovechamiento == "") {
      setStyle2(styles.textField2);
      setTasaImportAux(false);
    }
    if (!tasaImportacionAprovechamiento == "") {
      setStyle2(styles.textField2);
      setTasaImportAux(true);
    }
    if (noPedimentoImportacionCITIES == "") {
      setStyle3(styles.textField2);
      setNoPedimentoAux(false);
    }
    if (!noPedimentoImportacionCITIES == "") {
      setStyle3(styles.textField2);
      setNoPedimentoAux(true);
    }
    if (autorizacionUsoInfoComprador == undefined) {
      setStyle4(styles.textField2);
      setAutorizacionInfoCompAux(false);
    }
    if (
      autorizacionUsoInfoComprador == "No" ||
      autorizacionUsoInfoComprador == "Si"
    ) {
      setStyle4(styles.textField2);
      setAutorizacionInfoCompAux(true);
    }
    if (descripcionEjemplar == "") {
      setStyle6(styles.textField2);
      setDescripcionEjemplarAux(false);
    }
    if (!descripcionEjemplar == "") {
      setStyle6(styles.textField2);
      setDescripcionEjemplarAux(true);
    }
    if (nombreCientifico == "") {
      setStyle7(styles.textField2);
      setNombreCientificoAux(false);
    }
    if (!nombreCientifico == "") {
      setStyle7(styles.textField2);
      setNombreCientificoAux(true);
    }
    if (tipoMarcajeNumeroMarcaje == "") {
      setTipoNumeroMArcajeAux(false);
    }
    if (!tipoMarcajeNumeroMarcaje == "") {
      setTipoNumeroMArcajeAux(true);
    }
    if (incluirHolograma == "") {
      setIncluirHologramaAux(false);
    }
    if (!incluirHolograma == "") {
      setIncluirHologramaAux(true);
    }
    if (sexoAnimal == undefined) {
      setSexoAnimalAux(false);
    }
    if (!sexoAnimal == undefined) {
      setSexoAnimalAux(true);
    }
    if (noAprovechamiento == "") {
      setNoAprovAux(false);
    }
    if (!noAprovechamiento == "") {
      setNoAprovAux(true);
    }
    if (datosPredioAprovechamiento == "") {
      setDatosPredioAprovAux(false);
    }
    if (!datosPredioAprovechamiento == "") {
      setDatosPredioAprovAux(true);
    }
    if (edad == "") {
      setEdadAux(false);
    }
    if (!edad == "") {
      setEdadAux(true);
    }
    if (pesoAproximado == "") {
      setPesoAproximadoAux(false);
    }
    if (!pesoAproximado == "") {
      setPesoAproximadoAux(true);
    }
    if (color == "") {
      setColorAux(false);
    }
    if (!color == "") {
      setColorAux(true);
    }
    if (precio == "") {
      setPrecioAux(false);
    }
    if (!precio == "") {
      setPrecioAux(true);
    }
    if (telefonoSucursal == "") {
      setTelefonoSucursalAux(true);
    }
    if (telefonoSucursal !== "") {
      setTelefonoSucursalAux(false);
    }
  };

  var dataFormulario = {
    SKU,
    descripcionEjemplar,
    nombreCientifico,
    noPedimentoImportacionCITIES,
    tipoMarcajeNumeroMarcaje,
    tasaImportacionAprovechamiento,
    noAprovechamiento,
    datosPredioAprovechamiento,
    sexoAnimal,
    infoGeneral: `Edad: ${edad || ""},
    Peso Aproximado: ${pesoAproximado || ""}, 
    Color: ${color || ""}`,
    precio,
    nombreVendedor,
    tienda,
    telefonoSucursal,
    nombreComprador,
    direccion,
    estado,
    codigoPostal,
    telefonoComprador,
    emailComprador,
    cedulaProfesional,
    vacunasYDesparacitacion,
    esterilizado,
    firmaVendedor,
    fecha,
    aniosFecha,
    diasFecha,
    MesFecha,
    noMVZ,
    autorizacionUsoInfoComprador,
    selectedSexo,
    selectedVacunas,
    selectedEsterilizacion,
    fechaActual,
  };
  const getLastFolio = async () => {
    const insertarFolioM = await axios.post(
      `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/folios/crearFolio`,
      {
        tienda: tiendaAsociadaContext,
        idVendedor: userData.idNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
          apikey: `${process.env.REACT_APP_APIKEY}`,
          "Content-Type": "application/json",
        },
      },
    );
    const ultimoFolioRegistrado = await axios.post(
      `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/folios/consultarUltimoFolio`,
      {
        tienda: tiendaAsociadaContext,
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
          apikey: `${process.env.REACT_APP_APIKEY}`,
          "Content-Type": "application/json",
        },
      },
    );
    setIdGeneradoContext(ultimoFolioRegistrado.data.folio);
    setReloadTipografia(!reloadTipografia);
  };
  const seterEstado = (estadoValue) => {};
  useEffect(() => {
    const obtenerFechaActual = () => {
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();
      month = month < 10 ? `0${month}` : month;
      day = day < 10 ? `0${day}` : day;

      return `${day}-${month}-${year}`;
    };
    getDiaMesAnio();
    const fechaActual = obtenerFechaActual();
    setFechaActual(fechaActual);
    setFecha(fechaActual);
  }, [auxURL]);
  const handleEnviarInf = () => {
    navigate("/Pdf");
  };
  const handleChangeSexo = (e) => {
    setSelectedSexo(e.target.value);
    setSexoAnimal(e.target.value);
    setSexoAnimalAux(true);
  };
  const handleChangeVacunas = (e) => {
    setSelectedVacunas(e.target.value);
    setVacunasyDesparasitacion(e.target.value);
  };
  const handleChangeEsterilizacion = (e) => {
    setSelectedEsterilizacion(e.target.value);
    setEsterilizado(e.target.value);
  };
  const handleCheckboxChange = (e) => {
    const { name } = e.target;
    setSelectedOption(name);
    if (name == "Si") {
      setAutorizacionUsoInformacion("Si");
      setAutorizacionInfoCompAux(true);
      return;
    }
    if (name == "No") {
      setAutorizacionUsoInformacion("No");
      setAutorizacionInfoCompAux(true);
      return;
    }
  };
  const handleCheckboxChange2 = (e) => {
    const { name } = e.target;
    setSelectedOption2(name);
    if (name == "Si") {
      setIncluirHologramaAux(true);
      setIncluirHolograma("Si");
      return;
    }
    if (name == "No") {
      setIncluirHolograma("No");
      setIncluirHologramaAux(true);
      return;
    }
  };

  const isValidEmail2 = (value) => {
    if (value === "") {
      setEmailComprador(value);
    } else {
      value = value.toLowerCase().trim().replace(/\s+/g, "");
      setEmailComprador(value);
    }
  };

  const isValidName = (name) => {
    const twoWordsRegex = /^\s*\S+\s+\S+/;
    if (!twoWordsRegex.test(name)) {
      return false;
    } else {
      return true;
    }
  };

  const isValidEmail = async (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      return {
        formato: false,
      };
    } else {
      return {
        formato: true,
      };
    }
  };

  const handleChangeCodigoPostal = async (e) => {
    const codigoPostal = e.target.value;
    if (/^$|^\d+$/.test(codigoPostal)) {
      setCodigoPostal(codigoPostal);
      if (codigoPostal.length === 5) {
        try {
          const estado = await axios.get(
            `${process.env.REACT_APP_CODIGO_POSTAL}/${codigoPostal}`,
            {
              headers: {
                "x-api-pe-wss": `${process.env.REACT_APP_X_API_PE_WSS}`,
              },
            },
          );
          getInfoByPostalCode(codigoPostal);
          setEstado(estado.data.data.estado);
          setCodigoPostal(codigoPostal);
          setErrorCP(false);
        } catch (error) {
          if ((error.response.data.replyCode = 400)) {
            Swal.fire({
              title: "Error",
              text: "Lo sentimos, el código postal no existe. Por favor verificar.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#00205B",
              iconColor: "red",
            });
            setCodigoPostal("");
            setErrorCP(false);
            return;
          }
          Swal.fire({
            title: "Error",
            text: "Error en servicio Encontrar Ciudad, reportar a Mesa de Ayuda",
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#00205B",
            iconColor: "red",
          });
        }
      } else {
        getInfoByPostalCode(codigoPostal);
        if (codigoPostal.length == 0) {
          setErrorCP(false);
        }
      }
    }
  };

  function getDiaMesAnio() {
    var fecha = new Date();
    var dia = fecha.getDate();
    var mes = fecha.getMonth() + 1;
    var anio = fecha.getFullYear();
    setDiasFecha(dia.toString());
    setMesFecha(mes.toString());
    setAniosFecha(anio.toString());
    return `${dia.toString()}/${mes.toString()}/${anio.toString()}`;
  }

  const estadoValue =
    infoByPostalCode &&
    infoByPostalCode.data &&
    infoByPostalCode.data.estado !== null &&
    infoByPostalCode.data.estado !== undefined
      ? infoByPostalCode.data.estado
      : "____";

  return (
    <Card style={styles.formContainer} variant="outlined">
      <div style={styles.contenedorStyle2} className="style-scroll">
        <span style={{ color: "gray" }}>
          Por favor ingresa los siguientes campos.
        </span>
        <div className="div-form">
          <div style={styles.divForm}>
            <p>SKU</p>
            <TextField
              required
              //disabled={disabled}
              inputProps={{ maxLength: 6 }}
              error={skuAux ? false : true}
              label="SKU"
              variant="outlined"
              onChange={async (e) => {
                if (e.target.value.length == 6) {
                  const respuestaAuxInfoSKU = await axios.get(
                    `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/skus/consultarSku/${e.target.value}`,
                    {
                      headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                        apikey: `${process.env.REACT_APP_APIKEY}`,
                        "Content-Type": "application/json",
                      },
                    },
                  );
                  console.log(
                    "respuestaAuxInfoSKU: ",
                    respuestaAuxInfoSKU.data.info,
                  );
                  if (
                    respuestaAuxInfoSKU.data.msg ==
                    "No se encontró información del SKU"
                  ) {
                    Swal.fire({
                      title: "Sku inválido",
                      text: "Favor de verificar.",
                      icon: "error",
                      confirmButtonColor: "#00205B",
                      iconColor: "red",
                    });
                    setSkuAux2(false);
                    setSKU(e.target.value);
                    setSkucontext(e.target.value);
                    return;
                  } else {
                    await getLastFolio();
                    // console.log(
                    //   "nombreCientifico: ",
                    //   respuestaAuxInfoSKU.data.msg.info.nombreCientifico
                    // );
                    // console.log(
                    //   "nombreComún",
                    //   respuestaAuxInfoSKU.data.msg.descripcionEjemplar
                    // );
                    setSKU(e.target.value);
                    setSkuAux2(true);
                    // localStorage.setItem("sku", e.target.value);
                    setSkucontext(e.target.value);
                    setNombreCientifico(
                      respuestaAuxInfoSKU.data.info.nombreCientifico,
                    );
                    setDescripcionEjemplar(
                      respuestaAuxInfoSKU.data.info.descripcionEjemplar,
                    );
                    setTiendaAsociadaAuxiliarContext(false);
                    setMostrarSelectTienda(false);
                  }
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Tasa de importación o aprovechamiento</p>
            <TextField
              required
              //disabled={disabled}
              // style={tasaImportAux ? styles.textField : styles.textField2}
              error={tasaImportAux ? false : true}
              label="Tasa de importación o aprovechamiento"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setTasaImportAux(true);
                }
                e.preventDefault();
                setTasaImportacionAProvechamiento(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Descripción del ejemplar y/o raza</p>
            <TextField
              //disabled={disabled}
              required
              error={descripcionEjemplarAux ? false : true}
              label="Descripción"
              variant="outlined"
              value={descripcionEjemplar}
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setDescripcionEjemplarAux(true);
                }
                e.preventDefault();
                setDescripcionEjemplar(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Nombre científico</p>
            <TextField
              required
              value={nombreCientifico}
              //disabled={disabled}
              error={nombreCientificoAux ? false : true}
              label="Nombre científico"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setNombreCientificoAux(true);
                }
                e.preventDefault();
                setNombreCientifico(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>N.º de pedimento, N.º de importación, N.º CITES</p>
            <TextField
              required
              //disabled={disabled}
              error={noPedimentoAux ? false : true}
              label="N.º De Pedimento"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setNoPedimentoAux(true);
                }
                e.preventDefault();
                setNoPedimentoImportacionCITIES(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Tipo de marcaje, N.º de marcaje</p>
            <TextField
              required
              //disabled={disabled}
              error={tipoNumeroMarcajeAux ? false : true}
              label="Tipo De Marcaje"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setTipoNumeroMArcajeAux(true);
                }
                e.preventDefault();
                setTipoMarcajeNumeroMarcaje(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            {/* cambiar border de los selects cuando no se incluya el dato*/}
            <p
              style={{
                color: incluirHologramaAux ? "black" : "red",
                fontWeight: sexoAnimalAux ? "light" : "bold",
              }}>
              Incluir holograma en formato
            </p>
            <FormControlLabel
              //disabled={disabled}
              style={styles.textField}
              label="Si"
              control={
                <Checkbox
                  checked={selectedOption2 === "Si"}
                  onChange={handleCheckboxChange2}
                  name="Si"
                />
              }
            />
            <FormControlLabel
              //disabled={disabled}
              label="No"
              checked={selectedOption2 === "No"}
              control={<Checkbox onChange={handleCheckboxChange2} name="No" />}
            />
          </div>
          <div style={styles.divForm}>
            <p>N.º Aprovechamiento</p>
            <TextField
              required
              //disabled={disabled}
              error={noAprovechamientoAux ? false : true}
              label="N.º Aprovechamiento"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setNoAprovAux(true);
                }
                e.preventDefault();
                setNoAprovechamiento(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p
              style={{
                color: sexoAnimalAux ? "black" : "red",
                fontWeight: sexoAnimalAux ? "light" : "bold",
              }}>
              Sexo del animal (Cuando Aplique)
            </p>
            <FormControl
              //disabled={disabled}
              error={sexoAnimalAux ? false : true}
              required
              style={styles.textField}>
              <InputLabel id="demo-simple-select-standard-label">
                Sexo Del Animal
              </InputLabel>
              <Select
                required
                error={sexoAnimalAux ? false : true}
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedSexo}
                onChange={handleChangeSexo}
                label="Sexo Del Animal">
                <MenuItem value={"Macho"}>Macho</MenuItem>
                <MenuItem value={"Hembra"}>Hembra</MenuItem>
                <MenuItem value={"No aplica"}>No aplica</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={styles.divForm}>
            <p>
              Datos del predio del aprovechamiento (nombre y responsable de la
              UMA y/o PIMVS)
            </p>
            <TextField
              required
              //disabled={disabled}
              error={datosPredioAprovAux ? false : true}
              label="Datos del predio del aprovechamiento"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  setDatosPredioAprovAux(true);
                }
                e.preventDefault();
                setDatosPredioAprovechamiento(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Edad</p>
            <TextField
              required
              //disabled={disabled}
              error={edadAux ? false : true}
              label="Edad"
              variant="outlined"
              value={edad}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^[a-zA-Z0-9ñÑ\s]*$/.test(inputValue)) {
                  setEdad(inputValue);
                  if (inputValue.length > 0) {
                    setEdadAux(true);
                  }
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Peso aproximado (Kg)</p>
            <TextField
              required
              //disabled={disabled}
              error={pesoAproximadoAux ? false : true}
              label="Peso Aproximado"
              variant="outlined"
              value={pesoAproximado}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setPesoAproximado(inputValue);
                  if (inputValue.length > 0) {
                    setPesoAproximadoAux(true);
                  }
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Color</p>
            <TextField
              //disabled={disabled}
              required
              error={colorAux ? false : true}
              label="Color"
              variant="outlined"
              value={color}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(inputValue)) {
                  e.preventDefault();
                  setColor(inputValue);
                  if (inputValue.length > 0) {
                    setColorAux(true);
                  }
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Precio (MXN)</p>
            <TextField
              required
              //disabled={disabled}
              error={precioAux ? false : true}
              label="Precio"
              variant="outlined"
              value={precio}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setPrecio(inputValue);
                  if (inputValue.length > 0) {
                    setPrecioAux(true);
                  }
                }
              }}
            />
          </div>

          <div style={styles.divForm}>
            <p>Teléfono de sucursal</p>
            <TextField
              required
              //disabled={disabled}
              error={telefonoSucursalAux}
              label="Teléfono de sucursal"
              inputProps={{ maxLength: 10, minLength: 8 }}
              variant="outlined"
              value={telefonoSucursal}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^$|^\d+$/.test(inputValue)) {
                  setTelefonoSucursal(inputValue);
                  if (inputValue.length == 8) {
                    setTelefonoSucursalAux(false);
                  }
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>E-mail del comprador</p>
            <TextField
              //disabled={disabled}
              error={emailCompradorAux ? false : true}
              id="email"
              label="E-mail Comprador"
              variant="outlined"
              value={emailComprador}
              onChange={(e) => isValidEmail2(e.target.value)}
            />
          </div>
          <div style={styles.divForm}>
            <p>Nombre del comprador</p>
            <TextField
              style={styles.textField}
              //disabled={disabled}
              error={errorNameComprador}
              value={nombreComprador}
              label="Nombre del comprador"
              variant="outlined"
              onChange={(e) => {
                e.preventDefault();
                let inputValue = e.target.value;
                inputValue = inputValue
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase());
                setnombreComprador(inputValue);
                if (inputValue.length > 0) {
                  setErrorNameComprador(false);
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Código Postal</p>
            <TextField
              style={styles.textField}
              //disabled={disabled}
              inputProps={{ maxLength: 5 }}
              label="C.P"
              error={errorCP}
              variant="outlined"
              value={codigoPostal}
              onChange={handleChangeCodigoPostal}
            />
          </div>
          <div style={styles.divForm}>
            <p>Teléfono del comprador</p>
            <TextField
              //disabled={disabled}
              style={styles.textField}
              label="Teléfono"
              inputProps={{ maxLength: 10 }}
              variant="outlined"
              value={telefonoComprador}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^$|^\d+$/.test(inputValue)) {
                  setTelefonoComprador(inputValue);
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Dirección</p>
            <TextField
              //disabled={disabled}
              style={styles.textField}
              label="Dirección"
              variant="outlined"
              onChange={(e) => {
                e.preventDefault();
                setDireccion(e.target.value);
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Estado</p>
            <TextField
              style={styles.textField}
              onChange={(e) => {
                e.preventDefault();
              }}
              value={estadoValue}
              disabled
            />
          </div>
          <div style={styles.divForm}>
            <p>Fecha</p>
            <TextField style={styles.textField} value={fechaActual} disabled />
          </div>
          <div style={styles.divForm}>
            <p>Vacunas y desparasitación (Cuando Aplique)</p>
            <FormControl style={styles.textField}>
              <InputLabel id="demo-simple-select-standard-label">
                Vacunas Y Desparasitación
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                //disabled={disabled}
                id="demo-simple-select-standard"
                value={selectedVacunas}
                onChange={handleChangeVacunas}
                label="Vacunas Y Desparasitación">
                <MenuItem value={"Si"}>Si</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"No aplica"}>No aplica</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={styles.divForm}>
            <p>Nombre del MVZ</p>
            <TextField
              style={styles.textField}
              //disabled={disabled}
              label="MVZ"
              value={noMVZ}
              variant="outlined"
              error={errorNameMvz}
              onChange={(e) => {
                e.preventDefault();
                let inputValue = e.target.value;
                inputValue = inputValue
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase());
                setNoMVZ(inputValue);
                if (inputValue.length > 0) {
                  setErrorNameMvz(false);
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p>Esterilizados (cuando aplique)</p>
            <FormControl style={styles.textField}>
              <InputLabel id="demo-simple-select-standard-label">
                Esterilizados
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                //disabled={disabled}
                id="demo-simple-select-standard"
                value={selectedEsterilizacion}
                onChange={handleChangeEsterilizacion}
                label="Esterilizados">
                <MenuItem value={"Si"}>Si</MenuItem>
                <MenuItem value={"No"}>No</MenuItem>
                <MenuItem value={"No aplica"}>No aplica</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={styles.divForm}>
            <p>Cédula profesional</p>
            <TextField
              style={styles.textField}
              //disabled={disabled}
              label="Cédula Profesional"
              variant="outlined"
              value={cedulaProfesional}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^[a-zA-Z0-9]*$/.test(inputValue)) {
                  setCedulaProfesional(inputValue.toUpperCase());
                }
              }}
            />
          </div>
          <div style={styles.divForm}>
            <p
              style={{
                color: AutorizacionInfoCompAux ? "black" : "red",
                fontWeight: sexoAnimalAux ? "light" : "bolder",
              }}>
              Autorización para la utilización de información
            </p>
            <FormControlLabel
              style={styles.textField}
              label="Si"
              control={
                <Checkbox
                  //disabled={disabled}
                  checked={selectedOption === "Si"}
                  onChange={handleCheckboxChange}
                  name="Si"
                />
              }
            />
            <FormControlLabel
              //disabled={disabled}
              label="No"
              checked={selectedOption === "No"}
              control={<Checkbox onChange={handleCheckboxChange} name="No" />}
            />
          </div>
        </div>
      </div>
      {
        <>
          {!loadingsppiner ? (
            <CustomButton
              style={styles.Guardarbtn}
              onClick={async (e) => {
                e.preventDefault();
                seterEstado(estadoValue);
                if (!tiendaAsociadaContext) {
                  Swal.fire({
                    title: "Selecciona una tienda.",
                    icon: "info",
                    iconColor: "#00205B",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                }
                if (SKU == "") {
                  Swal.fire({
                    title: "Campo SKU vacío.",
                    text: "Favor de validar",
                    icon: "error",
                    iconColor: "red",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                }
                if (!skuAux2) {
                  Swal.fire({
                    title: "EL SKU no existe",
                    text: "Favor de validar",
                    icon: "error",
                    iconColor: "red",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                }
                handleComprobarClick();
                if (
                  !SKU ||
                  !noPedimentoImportacionCITIES ||
                  !tasaImportacionAprovechamiento ||
                  autorizacionUsoInfoComprador == undefined ||
                  !descripcionEjemplar ||
                  !nombreCientifico ||
                  !tipoMarcajeNumeroMarcaje ||
                  !noAprovechamiento ||
                  !datosPredioAprovechamiento ||
                  !edad ||
                  !sexoAnimal ||
                  !pesoAproximado ||
                  !color ||
                  !precio ||
                  !telefonoSucursal
                ) {
                  Swal.fire({
                    title: "Error",
                    text: "Faltan datos. Favor de validar.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                    iconColor: "red",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                }
                if (
                  telefonoSucursal.length > 0 &&
                  telefonoSucursal.length < 8
                ) {
                  Swal.fire({
                    title: "Error",
                    text: "El teléfono de sucursal debe tener entre 8 y 10 dígitos.",
                    icon: "error",
                    iconColor: "red",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#00205B",
                  });
                  setTelefonoSucursalAux(true);
                  return;
                }
                if (telefonoSucursal.length >= 8 && telefonoSucursal <= 10) {
                  setTelefonoSucursalAux(false);
                }
                if (codigoPostal.length > 0 && codigoPostal.length < 5) {
                  setErrorCP(true);
                  Swal.fire({
                    title: "Error",
                    text: "El C.P debe tener 5 digitos.",
                    icon: "error",
                    iconColor: "red",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                }
                if (codigoPostal.length == 0) {
                  setErrorCP(false);
                }

                if (noMVZ) {
                  if (!isValidName(noMVZ)) {
                    Swal.fire({
                      title: "Error",
                      text: "El nombre del MVZ debe contener nombre y apellido",
                      icon: "error",
                      iconColor: "red",
                      confirmButtonText: "Aceptar",
                      confirmButtonColor: "#00205B",
                    });
                    setErrorNameMvz(true);
                    return;
                  } else {
                    setErrorNameMvz(false);
                  }
                } else {
                  setErrorNameMvz(false);
                }
                setLoadingSpinner(true); //aqui spinner
                if (nombreComprador) {
                  if (!isValidName(nombreComprador)) {
                    Swal.fire({
                      title: "Error",
                      text: "El nombre del comprador debe contener nombre y apellido",
                      icon: "error",
                      iconColor: "red",
                      confirmButtonText: "Aceptar",
                      confirmButtonColor: "#00205B",
                    });
                    setErrorNameComprador(true);
                    setLoadingSpinner(false); //aqui spinner

                    return;
                  } else {
                    setErrorNameComprador(false);
                  }
                } else {
                  setErrorNameComprador(false);
                }

                if (emailComprador) {
                  let validationResult = await isValidEmail(emailComprador);
                  //console.log("VALIDATION RESULT", validationResult);
                  if (validationResult.formato) {
                    setCorreoCompradorContext(emailComprador);
                  } else {
                    Swal.fire({
                      title: "Formato de correo de inválido",
                      text: "Favor de revisar",
                      icon: "error",
                      confirmButtonText: "Aceptar",
                      iconColor: "red",
                      confirmButtonColor: "#00205B",
                    });
                    setLoadingSpinner(false);

                    return;
                  }
                } else if (!emailComprador) {
                  setCorreoCompradorContext("");
                }
                try {
                  setIdGeneradoContext(idGeneradoContext);
                  const idG = idGeneradoContext;
                  setLoadingSpinner(true);
                  // //inicio
                  if (incluirHolograma == "Si") {
                    // localStorage.setItem("sku",SKU)
                    setSkucontext(SKU);
                    encodeData("FOLIO", idGeneradoContext);
                    encodeData("TERMINOS", "false");
                    encodeData("FINALIZAR1", "false");
                    const resp = await axios.post(
                      `${auxURL}/ventas/integracion2`,
                      {
                        arrayDatos1: {
                          //ingresar data a cada dato del formato
                          SKU: SKU || "",
                          descripcionEjemplar: descripcionEjemplar || "",
                          nombreCientifico: nombreCientifico || "",
                          noPedimentoImportacionCITIES:
                            noPedimentoImportacionCITIES || "",
                          infoMarcaje: tipoMarcajeNumeroMarcaje || "",
                          tasaAprovImport: tasaImportacionAprovechamiento || "",
                          NoAprovechamiento: noAprovechamiento || "",
                          datosPredioAprov: datosPredioAprovechamiento || "",
                          sexoAnimal: sexoAnimal || "",
                          edad: edad,
                          pesoAproximado: pesoAproximado,
                          color: color,
                          //infoGeneral: dataFormulario.infoGeneral || "",
                          precio: precio || "",
                          nombreVendedor: "{nombreVendedor}",
                          tienda: tiendaAsociadaContext || "", //obtener de L.S
                          telTienda: telefonoSucursal || "",
                          nombreComprador: nombreComprador || "",
                          estado: estado || "",
                          nombreMVZ: noMVZ || "",
                          codigoPostal: codigoPostal || "",
                          telefono: telefonoComprador || "",
                          email: emailComprador || "",
                          direccion: direccion || "",
                          cedulaProfesional: cedulaProfesional || "",
                          vacunasyDesparasitacion:
                            vacunasYDesparacitacion || "",
                          esterilizado: esterilizado || "",
                          fecha: fechaActual || "",
                          nombreImagenComprador: "",
                          idVendedor: userData.idNumber, //obtener de localStorage
                          firmaVendedor: "{%firmaVendedor}",
                          firmaComprador: "{%firmaComprador}",
                          noFolio: idG.toString(),
                          aniosFecha: aniosFecha,
                          diasFecha: diasFecha,
                          MesFecha: MesFecha,
                          autDatosSi:
                            autorizacionUsoInfoComprador === "Si" ? "X" : "",
                          autDatosNo:
                            autorizacionUsoInfoComprador === "No" ? "X" : "",
                          autPubliSi:
                            autorizacionUsoInfoComprador === "Si" ? "X" : "",
                          autPubliNo:
                            autorizacionUsoInfoComprador === "No" ? "X" : "",
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                          "Content-Type": "application/json",
                        },
                      },
                    );
                    //ENVIAR DATOS INDIVIDUALIZADOS
                    const enviarDataIndividual = axios.post(
                      `${auxURL}/ventas/crearVenta`,
                      {
                        iDVenta: idG,
                        sku: SKU,
                        descripcionEjemplar: descripcionEjemplar,
                        noPedimento: noPedimentoImportacionCITIES,
                        noImportacion: noPedimentoImportacionCITIES,
                        noCITES: noPedimentoImportacionCITIES,
                        marcaje: {
                          tipo: "-",
                          numero: tipoMarcajeNumeroMarcaje,
                        },
                        tasaImportacionAprovechamiento:
                          tasaImportacionAprovechamiento,
                        noAprovechamiento: noAprovechamiento,
                        nombreCientifico: nombreCientifico,
                        datosPredioAprovechamiento: {
                          nombreResponsableUmaoPIMVS:
                            datosPredioAprovechamiento,
                        },
                        edad: edad,
                        color: color,
                        pesoAprox: pesoAproximado,
                        precio: precio,
                        nombreComprador: nombreComprador,
                        direccion: direccion,
                        cp: codigoPostal,
                        telefonoComprador: telefonoComprador,
                        emailComprador: emailComprador,
                        MVZ: noMVZ,
                        cedulaProfesional: cedulaProfesional,
                        firmaPetco: "firmaComprador",
                        sexoAnimal: sexoAnimal,
                        estado: estadoValue,
                        vacunasDesparasitacion: vacunasYDesparacitacion,
                        esterilizado: esterilizado,
                        noFolio: idG,
                        nombreVendedor: "{nombreVendedor}",
                        tienda: userData,
                        telefonoTienda: telefonoSucursal,
                        fecha: fechaActual,
                        idG: idG,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEY}`,
                          "Content-Type": "application/json",
                        },
                      },
                    );
                    navigate("/Pdf");
                  }
                  if (incluirHolograma == "No") {
                    encodeData("FOLIO", idGeneradoContext);
                    encodeData("TERMINOS", "false");
                    encodeData("FINALIZAR1", "false");
                    const resp2 = await axios.post(
                      `${auxURL}/ventas/integracion`,
                      {
                        arrayDatos1: {
                          //ingresar data a cada dato del formato
                          SKU: SKU || "",
                          descripcionEjemplar: descripcionEjemplar || "",
                          nombreCientifico: nombreCientifico || "",
                          noPedimentoImportacionCITIES:
                            noPedimentoImportacionCITIES || "",
                          infoMarcaje: tipoMarcajeNumeroMarcaje || "",
                          tasaAprovImport: tasaImportacionAprovechamiento || "",
                          NoAprovechamiento: noAprovechamiento || "",
                          datosPredioAprov: datosPredioAprovechamiento || "",
                          sexoAnimal: sexoAnimal || "",
                          edad: edad,
                          pesoAproximado: pesoAproximado,
                          color: color,
                          //infoGeneral: dataFormulario.infoGeneral || "",
                          precio: precio || "",
                          nombreVendedor: "{nombreVendedor}",
                          tienda: tiendaAsociadaContext || "", //obtener de L.S
                          telTienda: telefonoSucursal || "",
                          nombreComprador: nombreComprador || "",
                          estado: estado || "",
                          nombreMVZ: noMVZ || "",
                          codigoPostal: codigoPostal || "",
                          telefono: telefonoComprador || "",
                          email: emailComprador || "",
                          direccion: direccion || "",
                          cedulaProfesional: cedulaProfesional || "",
                          vacunasyDesparasitacion:
                            vacunasYDesparacitacion || "",
                          esterilizado: esterilizado || "",
                          fecha: fechaActual || "",
                          nombreImagenComprador: "",
                          idVendedor: userData.idNumber,
                          firmaVendedor: "{%firmaVendedor}",
                          firmaComprador: "{%firmaComprador}",
                          noFolio: idG.toString(),
                          aniosFecha: aniosFecha,
                          diasFecha: diasFecha,
                          MesFecha: MesFecha,
                          autDatosSi:
                            autorizacionUsoInfoComprador === "Si" ? "X" : "",
                          autDatosNo:
                            autorizacionUsoInfoComprador === "No" ? "X" : "",
                          autPubliSi:
                            autorizacionUsoInfoComprador === "Si" ? "X" : "",
                          autPubliNo:
                            autorizacionUsoInfoComprador === "No" ? "X" : "",
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEY}`,
                          "Content-Type": "application/json",
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                          "Content-Type": "application/json",
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                          "Content-Type": "application/json",
                        },
                      },
                    );
                    //ENVIAR DATOS INDIVIDUALIZADOS
                    const enviarDataIndividual = await axios.post(
                      `${auxURL}/ventas/crearVenta`,
                      {
                        iDVenta: idG,
                        sku: SKU,
                        descripcionEjemplar: descripcionEjemplar,
                        noPedimento: noPedimentoImportacionCITIES,
                        noImportacion: noPedimentoImportacionCITIES,
                        noCITES: noPedimentoImportacionCITIES,
                        marcaje: {
                          tipo: "-",
                          numero: tipoMarcajeNumeroMarcaje,
                        },
                        tasaImportacionAprovechamiento:
                          tasaImportacionAprovechamiento,
                        noAprovechamiento: noAprovechamiento,
                        nombreCientifico: nombreCientifico,
                        datosPredioAprovechamiento: {
                          nombreResponsableUmaoPIMVS:
                            datosPredioAprovechamiento,
                        },
                        edad: edad,
                        color: color,
                        pesoAprox: pesoAproximado,
                        precio: precio,
                        nombreComprador: nombreComprador,
                        direccion: direccion,
                        cp: codigoPostal,
                        telefonoComprador: telefonoComprador,
                        emailComprador: emailComprador,
                        MVZ: noMVZ,
                        cedulaProfesional: cedulaProfesional,
                        firmaPetco: "firmaComprador",
                        sexoAnimal: sexoAnimal,
                        estado: estadoValue,
                        vacunasDesparasitacion: vacunasYDesparacitacion,
                        esterilizado: esterilizado,
                        noFolio: idG,
                        nombreVendedor: "{nombreVendedor}",
                        tienda: idG,
                        telefonoTienda: telefonoSucursal,
                        fecha: fechaActual,
                        idG: idG,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                          "Content-Type": "application/json",
                        },
                      },
                    );
                    navigate("/Pdf");
                  }
                } catch (error) {
                  //console.log("errror al enviar el formulario", error);
                }
              }}>
              ENVIAR
            </CustomButton>
          ) : (
            <></>
          )}
          {loadingsppiner && (
            <ClipLoader
              color="#0025B"
              cssOverride={{ position: "relative", top: "20px", left: "5px" }}
            />
          )}
        </>
      }
      <div
        className={`overlay ${showVentana ? "active" : "inactive"}`}
        id="overlay">
        <div className="popup-correo">
          <div className="btn-cerrar-popup">
            <span onClick={closeVentanaEmergente} title="Cerrar Ventana">
              x
            </span>
          </div>

          <div>
            <p>El siguiente correo no está dado de alta</p>
            <p>
              Correo comprador: <b>{emailComprador}</b>
            </p>
          </div>

          <p>Para poder continuar, seleccione una opción: </p>

          <div className="pz-center">
            <CustomButton
              style={styles.btnCorreo} //onClick={altaCorreo}
            >
              Dar de alta
            </CustomButton>
            <CustomButton
              style={styles.btnCorreo}
              onClick={closeVentanaEmergente}>
              Escribir otro
            </CustomButton>
          </div>
        </div>
      </div>
    </Card>
  );
};
const mapStateToProps = (state) => {
  return {
    users: state.users.users,
    userData: state.users.data,
    loadingStores: state.users.loading,
    infoByPostalCode: state.users.infoByPostalCode,
  };
};

const mapDispatchToProps = {
  getInfoByPostalCode: UsersCreators.getInfoByPostalCode,
};
export default connect(mapStateToProps, mapDispatchToProps)(FormularioFormato);
